module.exports = __webpack_public_path__ + "34ed2f24b50edf07808df2d0917363a7.svg";